<form [formGroup]="Tab">
  <div class="topfields">
    <mat-form-field>
      <mat-label>Title</mat-label>
      <input matInput formControlName="Title">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Record</mat-label>
      <input matInput formControlName="RecordKey">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Type</mat-label>
      <mat-select [formControl]="Type">
        <mat-option *ngFor="let type of eTabType | keyvalue" [value]="type.value">{{type.value}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Email</mat-label>
      <mat-select [formControl]="UserID">
        <mat-option value="Default">Default</mat-option>
        <mat-option *ngFor="let e of Email" [value]="e">{{e}}</mat-option>
      </mat-select>
    </mat-form-field>
    <div class="created">
      <mat-label>Created:</mat-label>
      {{ Created | date: "short" }}
    </div>
    <div class="modified">
        <mat-label>Last Modified:</mat-label>
        {{ Modified | date: "short" }}
    </div>
  </div>
  <mat-accordion>
      <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Table Manager
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-tableprofile [table]="Table"></app-tableprofile>
      </mat-expansion-panel>
      <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Note Manager
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-note [note]="Note"></app-note>
      </mat-expansion-panel>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title>
            Exclusion Manager
          </mat-panel-title>
        </mat-expansion-panel-header>
        <app-select-list name="Exclusion List" [Selections]="blacklist" (changes)="onChangeBlackList($event)"></app-select-list>
      </mat-expansion-panel>
  </mat-accordion>
</form>
